export class Echelon {
  constructor (id, options = null) {
    this.id = id
    this.engins = []
  }
/*
  addEngin (engin) {
    console.log('echelon.js - addEngin')
    this.engins.push(engin)
  }
  */
}

Echelon.createEchelonFromDb = (echelonFromDB) => {
  let e = new Echelon()
  echelonFromDB.data.engins.forEach(eng => {
    e.engins.push(eng)
  })
  e.id = echelonFromDB.id
  return e
}

export class Engin {
  constructor (options = {}) {
    this.famille = options.famille
    this.engin = options.engin
    this.code = options.code
    this.option = options.option
  }
}



// WEBPACK FOOTER //
// ./src/client/common/models/echelon.js